import { createLogger } from '@superbet-group/web.lib.vue-utilities';

import { commonConfig as config } from '@src/config/common';

export const logger = createLogger({
    dsn: 'https://dceafea30f9e4cbdae87371a7a0f5fd2@sentry.io/1303729',
    sampleRate: 0.01,
    environment: config.environment.name,
    version: config.environment.version,
    isProduction: config.environment.isProduction,
    isTest: config.environment.isTest,
});
